import React, { useState, useEffect } from "react";
import LeftSideBar from "../sidebar/LeftSideBar";
import Header from "../sidebar/Header";
import {  getAllPodcast } from "../apiconfig/authService";
import { Pagination } from "rsuite";
import "rsuite/dist/rsuite.min.css";
export default function Podcast() {
  const [contentFeedbackList, setAllContentFeedbackList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refetchData, setRefetchData] = useState(false);

  function parseDuration(duration) {
    const regex = /PT(\d+H)?(\d+M)?(\d+S)?/;
    const matches = duration.match(regex);

    if (!matches) {
        return null; // Invalid format
    }

    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (matches[1]) {
        hours = parseInt(matches[1], 10);
    }
    if (matches[2]) {
        minutes = parseInt(matches[2], 10);
    }
    if (matches[3]) {
        seconds = parseInt(matches[3], 10);
    }

    // Format the output nicely
    return `${hours > 0 ? hours + ' hour' : ''} ${minutes > 0 ? minutes + ' minute' : ''} ${seconds > 0 ? seconds + ' second' : ''}`.trim();
}

  const getAllPodcastData = async () => {
    try {
      const response = await getAllPodcast(
        pageSize === "All" ? totalCount : pageSize,
        pageSize === "All" ? 1 : pageNo
      );
      setAllContentFeedbackList(response.data);
      setTotalCount(response.pagination.totalCount);
      setTotalPages(Math.ceil(response.pagination.totalPages));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllPodcastData();
  }, [pageNo, refetchData]);
  const handlePageSizeChange = (e) => {
    setPageSize(e.target.value);
    setPageNo(1);
    setRefetchData(!refetchData);
  };

  return (
    <>
      <Header />
      <div className="col12SwmDashBord bg-white ">
        <div className="col4SemNvr">
          <LeftSideBar />
        </div>
        <div className="col8SemNvr mt-[70px] ml-[5%]">
          <div className="flex justify-between items-end mb-5">
            <div className="grid grid-cols-12">
              <div className="col-span-10 ">
                <div className="HdingSwnvr my-3 px-5">
                  <h5> Podcasts </h5>
                </div>
              </div>
            </div>
          </div>

          <div className="flex col12WdthSwhnMn mt-2">
            <div className="flex">
              <label>Show </label>
              <div class="flex mt-[-2px] mr-2 ml-2 items-center ServeCtgrySwn">
                <div class="relative w-full">
                  <select
                    className="bg-gray-50 py-1 border border-gray-300 text-gray-500 text-sm rounded-sm  block w-full px-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white "
                    value={pageSize}
                    onChange={handlePageSizeChange}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                    <option value={500}>500</option>
                    <option value="All">All</option>
                  </select>
                </div>
              </div>
              <label> records per page. </label>
            </div>
            <div class=" relative  shadow-md sm:rounded-lg  mt-5">
              <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 ">
                <thead class="text-sm text-gray-700 uppercase bg-orange-100	 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" class="py-4 px-4">
                      S No.
                    </th>
                    <th scope="col" class="py-4 px-4">
                      Thumbnail
                    </th>
                    <th scope="col" class="py-4 px-4">
                      Title
                    </th>
                    <th scope="col" class="py-4 px-4">
                      ID
                    </th>
                    <th scope="col" class="py-4 px-4">
                      Duration
                    </th>
                    <th scope="col" class="py-4 px-4">
                      Published At
                    </th>

                  </tr>
                </thead>

                <tbody className="TableService">
                  {contentFeedbackList &&
                    contentFeedbackList.map((data, index) => (
                      <tr
                        class="bg-white border-b dark:bg-gray-900 dark:border-gray-700"
                        key={index}
                      >
                        <th
                          scope="row"
                          class="py-3 px-4 font-medium text-sm text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {index + 1}.
                        </th>
                        <td class="py-3 text-sm px-4">
                          <img src={data?.thumbnails?.default?.url} />
                        </td>
                        <td class="py-3 text-sm px-4">{data?.title.slice(0,20)} {data?.title.length > 20 && "..."}</td>
                        <td class="py-3 text-sm px-4">{data?.id  }</td>
                        <td class="py-3 text-sm px-4">{parseDuration(data?.duration)  }</td>

                        <td class="py-3 text-sm px-4">
                          {new Date(data?.publishedAt).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className=" pb-[20px] pl-[20px] pr-[20px] w-full flex justify-between mt-3">
            {totalCount === 0 ? (
              <div>Showing 0 - 0 entries of 0 entries. </div>
            ) : pageSize === "All" ? (
              <div>
                Showing {1} - {totalCount} entries of {totalCount} entries.
              </div>
            ) : (
              <div>
                Showing {(pageNo - 1) * pageSize + 1} -{" "}
                {totalCount < pageSize * pageNo
                  ? totalCount
                  : pageSize * pageNo}{" "}
                entries of {totalCount} entries.
              </div>
            )}
            {/* Pagination Start */}
            <div style={{ margin: "100" }}>
              <Pagination
                prev
                last
                next
                first
                size="sm"
                ellipsis
                boundaryLinks
                onSelect={setPageNo}
                limit={pageSize === "ALL" ? totalCount : pageSize}
                onChangeLimit={setPageSize}
                layout={["pager", "skip"]}
                pages={totalPages}
                total={totalCount}
                maxButtons={5}
                activePage={pageNo}
                onChangePage={(page) => {
                  setPageNo(page);
                }}
              />
            </div>
            {/* Pagination End */}
          </div>
        </div>
      </div>
    </>
  );
}
